import * as React from 'react';
import { FIELD_TYPE } from 'app/infrastructure/simple-form';
import { FilterCommonProps } from '../types';
import { customFilterFieldPostfix } from 'app/components/filters/filters-panel/constants';
import { OptionTypes, FilterOption, ConditionValuesOperator } from 'app/components/filters/types';
import { FilterOptionType } from 'app/area/filters/types';
import { RadioSymbol } from 'ui';

export interface FilterDecimalProps extends FilterCommonProps {
  onFilterOptionType: (filterOption: FilterOption, filterOptionType: FilterOptionType) => void;
}

export class FilterDecimal extends React.Component<FilterDecimalProps> {
  private handleOptionChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
    const selectedOption = Number(e.currentTarget.value);

    this.props.onFilterOptionType({
      id: this.props.filterDomain.id,
      type: selectedOption
    }, FilterOptionType.OPTION_TYPE);
  };

  private renderDecimalNumbers = () => {
    const { simpleFormComponent: SimpleForm, initialValue, filterDomain: { id: name, optionType, conditions }, translation } = this.props;

    const selected = optionType !== OptionTypes.NotSpecified;
    const conditionOperator = !!conditions?.length && conditions[0].values[0]?.operator.v;
    const initialValueFrom = !!initialValue?.length ? (conditionOperator === ConditionValuesOperator.lessOrEqual ? '' 
      : initialValue[0].value) : '';
    const initialValueTo = !!initialValue?.length && initialValue[0] ? (conditionOperator === ConditionValuesOperator.lessOrEqual ? 
      initialValue[0].value : initialValue[0].value2) : '';

    return <div>
      <div className="form-check">
        <input
          id={`${this.props.filterDomain.id}-specific-numbers-or-ranges`}
          type="radio"
          className="form-check-input visuallyhidden"
          value={OptionTypes.SpecificNumbersOrRanges}
          checked={selected}
          onChange={this.handleOptionChange} />
        <label
          htmlFor={`${this.props.filterDomain.id}-specific-numbers-or-ranges`}
          className="form-check-label">
          <RadioSymbol />
          <div>
            <b>{translation.filters_specific_numbers_ranges_title}</b>
            <p>{translation.filters_specific_numbers_ranges_subtitle}</p>
          </div>
        </label>

        {selected && <>
          <h3>{this.props.translation.filters_decimal_range}</h3>
          <div className="row">
            <div className="col col-md-6">
              <SimpleForm
                name={name + customFilterFieldPostfix.decimalFrom}
                type={FIELD_TYPE.DECIMAL_NUMBER}
                initialValue={initialValueFrom}
                errorMessage={translation.filters_must_be_withing_range}
                maxDecimals={4}
              />
            </div>
            <div className="col col-md-6">
              <SimpleForm
                name={name + customFilterFieldPostfix.decimalTo}
                type={FIELD_TYPE.DECIMAL_NUMBER}
                initialValue={initialValueTo}
                errorMessage={translation.filters_must_be_withing_range}
                maxDecimals={4}
              />
            </div>
          </div></>}
      </div>
    </div>;
  };

  private renderNotSpecified = () => {
    const { simpleFormComponent, translation, filterDomain: { id: name, optionType } } = this.props;
    const SimpleForm = simpleFormComponent;
    const selected = optionType === OptionTypes.NotSpecified;

    return <div className="form-check">
      <input
        id={`${this.props.filterDomain.id}-not-specified`}
        type="radio"
        className="form-check-input visuallyhidden"
        value={OptionTypes.NotSpecified}
        checked={selected}
        onChange={this.handleOptionChange} />
      <label
        htmlFor={`${this.props.filterDomain.id}-not-specified`}
        className="form-check-label">
        <RadioSymbol />
        <div>
          <b>{translation.filters_not_specified_title}</b>
          <p>{translation.filters_not_specified_subtitle}</p>
        </div>
        {selected && <div className="d-none">
          <SimpleForm
            name={name + customFilterFieldPostfix.notSpecified}
            type={FIELD_TYPE.TEXTAREA}
            initialValue={translation.filters_not_specified_title}
          />
        </div>}
      </label>
    </div>;
  };

  public render() {
    return <>
      {this.renderDecimalNumbers()}
      {this.renderNotSpecified()}
    </>;
  }
}
